import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import FooterOne from "../components/FooterOne";
import HeaderOne from "../components/HeaderOne";
import LessonDetails from "../components/LessonDetails";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const LessonDetailsPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Courses Details"} />

      {/* LessonDetails */}
      <LessonDetails />

      {/* CertificateOne */}
      <CertificateOne />

      {/* FooterOne */}
      
    </>
  );
};

export default LessonDetailsPage;
